module.exports = __webpack_public_path__ + "medium-arrow.png?1fd7cecccc0f54aff06d99c4dd2f7b8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/medium-arrow.png
// module id = 69
// module chunks = 0